import { useEffect, useState } from "react";
import { Users } from "lucide-react";
import { toast } from "sonner";
import api, { getError } from "@/api";
import { PdfFileActions } from "@/components/PdfFileActions";

export default function StaffPage() {
  const [staff, setStaff] = useState([]);
  const [selected, setSelected] = useState(null);
  useEffect(() => { api.get("/staff").then((r) => setStaff(r.data)).catch((e) => toast.error(getError(e))); }, []);
  const open = async (id) => { try { const r = await api.get(`/staff/${id}`); setSelected(r.data); } catch (e) { toast.error(getError(e)); } };
  const getStaffPdfBlob = async () => {
    const response = await api.get("/staff/report/pdf", { responseType: "blob" });
    return response.data;
  };

  return (
    <div className="page-enter" data-testid="staff-page">
      <div className="page-heading">
        <div>
          <p className="eyebrow">ADMINISTRATION</p>
          <h1>Liste du personnel</h1>
          <p>Répertoire général des utilisateurs et de leurs matricules.</p>
        </div>
        <div data-testid="staff-report-pdf-actions">
          <PdfFileActions
            fileName="liste-personnel.pdf"
            getPdfBlob={getStaffPdfBlob}
            testIdPrefix="staff-report"
          />
        </div>
      </div>
      <section className="data-panel">
        <div className="panel-heading">
          <div>
            <p className="eyebrow">EFFECTIF</p>
            <h2>{staff.length} utilisateur(s)</h2>
          </div>
          <Users size={20} />
        </div>
        <div className="responsive-table">
          <table data-testid="staff-table">
            <thead>
              <tr>
                <th>Matricule</th>
                <th>Utilisateur</th>
                <th>Rôle</th>
                <th>Téléphone</th>
                <th>Adresse</th>
                <th>E-mail</th>
                <th>Service</th>
              </tr>
            </thead>
            <tbody>
              {staff.map((item) => (
                <tr
                  data-testid={`staff-row-${item.user_id}`}
                  key={item.user_id}
                  onClick={() => open(item.user_id)}
                  style={{ cursor: "pointer" }}
                >
                  <td>{item.employee_number}</td>
                  <td><strong>{`${item.first_name} ${item.last_name}`.trim() || item.name}</strong></td>
                  <td>{item.role.replaceAll("_", " ")}</td>
                  <td>{item.phone || "—"}</td>
                  <td>{item.address || "—"}</td>
                  <td>{item.email}</td>
                  <td>{item.service_date || "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
      {selected && (
        <div className="document-modal" data-testid="staff-detail-modal">
          <div className="catalogue-preview-window">
            <header>
              <h2>{`${selected.first_name} ${selected.last_name}`.trim() || selected.name}</h2>
              <button data-testid="close-staff-detail-button" onClick={() => setSelected(null)}>
                ×
              </button>
            </header>
            <div data-testid="staff-detail-content" style={{ padding: 24 }}>
              <p><strong>Matricule :</strong> {selected.employee_number}</p>
              <p><strong>Rôle :</strong> {selected.role.replaceAll("_", " ")}</p>
              <p><strong>Téléphone :</strong> {selected.phone || "—"}</p>
              <p><strong>Adresse :</strong> {selected.address || "—"}</p>
              <p><strong>E-mail :</strong> {selected.email}</p>
              <p><strong>Date de service :</strong> {selected.service_date || "—"}</p>
              <p><strong>Identifiant :</strong> {selected.username || "—"}</p>
              <p><strong>Statut :</strong> {selected.active ? "Actif" : "Inactif"}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}